import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  widgetFailed: "Couldn't load this widget.",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    widgetFailed: "Impossible de charger ce widget.",
  },
  es_ES: {
    widgetFailed: "No se pudo cargar este widget.",
  },
  pt_BR: {
    widgetFailed: "Não foi possível carregar este widget.",
  },
  de_DE: {
    widgetFailed: "Dieses Widget konnte nicht geladen werden.",
  },
  it_IT: {
    widgetFailed: "Impossibile caricare questo widget.",
  },
  ar: {
    widgetFailed: "تعذّر تحميل هذه الأداة.",
  },
  ja_JP: {
    widgetFailed: "このウィジェットを読み込めませんでした。",
  },
  hi_IN: {
    widgetFailed: "यह विजेट लोड नहीं हो सका।",
  },
  zh_CN: {
    widgetFailed: "无法加载此小组件。",
  },
  zh_TW: {
    widgetFailed: "無法載入此小工具。",
  },
  nl_NL: {
    widgetFailed: "Kan deze widget niet laden.",
  },
  nb_NO: {
    widgetFailed: "Kunne ikke laste denne widgeten.",
  },
  sv_SE: {
    widgetFailed: "Det gick inte att läsa in den här widgeten.",
  },
  fi_FI: {
    widgetFailed: "Tätä widgetiä ei voitu ladata.",
  },
  da_DK: {
    widgetFailed: "Kunne ikke indlæse denne widget.",
  },
  is_IS: {
    widgetFailed: "Ekki tókst að hlaða þessari græju.",
  },
};
